(function () {

    'use strict';

    angular.module('iplusjs.utils.uppercase', [])
        .directive('iplusjsUppercase', uppercase);

    uppercase.$inject = [];
    function uppercase() {
        return {
            restrict: 'A',
            require: 'ngModel',
            priority: 1000,
            link: function ($scope, $elem, $attrs, $ngModel) {
                $ngModel.$parsers.push(function (value) {
                    var formatedValue = value && value.toUpperCase();

                    if (value !== formatedValue) {
                        $ngModel.$viewValue = formatedValue;
                        $ngModel.$setViewValue(formatedValue);
                        $ngModel.$commitViewValue();
                        $ngModel.$render();
                    }

                    return formatedValue;
                });

                $elem.css('text-transform','uppercase');
            }
        };
    }
})();
